import { Component, OnInit } from '@angular/core';
import { UtilService } from './services/util.service';
import { ActivatedRoute } from '@angular/router';
import { ConstantData } from './services/constants';
import { RouteConstants } from 'src/assets/constants/route';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private util:UtilService, private router: ActivatedRoute){
    window.onpopstate = this.onpopstate;
  }

  onpopstate() {
    window.history.go(1);
  }

  ngOnInit() {
    sessionStorage.removeItem('data');
    const isSponser = !!(+(localStorage.getItem('isSponser')|| '0'));
    let data: any = window.location.search;


   const routes:any  = RouteConstants.routes;
    
     const ishomeRoute:any = routes[sessionStorage.getItem('route')|| ''] === routes.home || routes[sessionStorage.getItem('route')|| ''] === routes.main;
     
     
    
     sessionStorage.setItem('ishomeRoute',ishomeRoute);
   

    
    data = data.substring(1).split('&').map((e: any) => {
      return { [e.split('=')[0]]: e.split('=')[1] };
    });

    const obj:any = {};
    data.forEach((e: any) => {
      var d = Object.keys(e);
      obj[d[0]] = e[d[0]];
    });

    
    if(obj.status && obj.EV){
      if(isSponser){
        localStorage.setItem('isSponser','0');
        localStorage.setItem('emailVerified','1');
        window.close();
      }else{
        this.util.addEmailId(obj)
      }
    }
    else
    this.util.getToken(obj.code || '',undefined,false,obj.output);

    if(obj.mode === 'edit' && obj.phoneNumber){
      sessionStorage.setItem('data', JSON.stringify(obj));
      this.util.route('login');
    
    }else{
      const routes = sessionStorage.getItem('route');
      if( (routes === 'main' || routes === 'login')){
        sessionStorage.setItem('route','home');
      }
    }

  }





}
